'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.appconfgroups.edit', [])
  .controller('AppConfGroupsEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfgroups/edit/index.js